export const CHARGE_FREQUENCIES = {
  MONTHLY: 'MONTHLY',
  ANNUALLY: 'ANNUALLY',
};
